import { THPropsWithoutRef } from "react-html-props";
import styled from "styled-components";
import collapsable, { CollapsableProps } from "./collapsable";

export interface THProps extends THPropsWithoutRef, CollapsableProps {}

const Th = styled.th<THProps>`
  ${collapsable};

  padding: 1rem;
  color: ${({ theme }) => theme.colors.text};
`;

export default Th;
